import React from "react";
import { HighChart } from "../Generic/Charts";

const SplineChart: React.FC<{
  chartName: string;
  categories: string[];
  data: number[];
  yAxisTitle: string;
}> = ({ chartName, categories, data, yAxisTitle }) => {
  const chartOptions = {
    chart: {
      type: "spline",
    },
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    xAxis: {
      categories: categories,
      accessibility: {
        description: "",
      },
    },
    yAxis: {
      title: {
        text: yAxisTitle,
      },
      labels: {
        format: "${value}",
      },
    },
    tooltip: {
      crosshairs: true,
      shared: true,
    },
    plotOptions: {
      spline: {
        marker: {
          radius: 4,
          lineColor: "#666666",
          lineWidth: 1,
        },
      },
    },
    series: [
      {
        name: chartName,
        marker: {
          symbol: "square",
        },
        data: data,
      },
    ],
  };
  return (
    <HighChart cardTitleLarge={chartName} colSize="12" options={chartOptions} />
  );
};

export default SplineChart;
